import React from 'react'

function Deposits() {
  return (
    <div>Deposits</div>
  )
}

export default Deposits